// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oPBx","rootNoMargin":"styles_rootNoMargin__2RY13"};